import { format } from 'date-fns';

/** Placeholder rendered when a date is absent or unparseable. */
export const EMPTY_DATE = '—';

/**
 * Formats a display date from an epoch-ms number or an ISO-8601 string.
 * Returns {@link EMPTY_DATE} for null / undefined / empty / invalid input.
 * The default pattern matches the app's short table style (e.g. `01/Sep/25`).
 */
export const formatDisplayDate = (value?: number | string | null, pattern = 'dd/MMM/yy'): string => {
  if (value == null || value === '') return EMPTY_DATE;
  const date = new Date(value);
  return Number.isNaN(date.getTime()) ? EMPTY_DATE : format(date, pattern);
};
